import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchGroceryByIdArgs,
  FetchGroceriesArgs,
} from '../api/types/groceries.types';

import { fetchGroceryById, fetchGroceries } from '../api/groceries.api';

export const groceriesQueryKeys = createQueryKeys('groceries', {
  fetchGroceries: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchGroceriesArgs) => ({
    queryFn: () =>
      fetchGroceries({ contentFilters, locale, organizationId, tableFilters }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
  fetchGroceryById: ({
    id,
    locale,
    organizationId,
    userUnitSettings,
  }: FetchGroceryByIdArgs) => ({
    queryFn: () =>
      fetchGroceryById({ id, locale, organizationId, userUnitSettings }),
    queryKey: [id, organizationId, locale],
  }),
  fetchInfiniteGroceries: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchGroceriesArgs) => ({
    queryFn: (context?: { pageParam?: unknown }) =>
      fetchGroceries({
        contentFilters,
        locale,
        organizationId,
        tableFilters: {
          ...tableFilters,
          offset: (context?.pageParam as string) || '1',
        },
      }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
});
